export default __webpack_public_path__ + "static/korzystne-warunki-690b359113341bce7c9fda08847521af.png";